import { render, staticRenderFns } from "./for-media.vue?vue&type=template&id=fc0f0448&scoped=true&"
import script from "./for-media.vue?vue&type=script&lang=js&"
export * from "./for-media.vue?vue&type=script&lang=js&"
import style0 from "./for-media.vue?vue&type=style&index=0&id=fc0f0448&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0f0448",
  null
  
)

export default component.exports